import { Orientation, PageOrientations } from '@app/features/documents/document.model';

/** Sens d'un quart de tour. */
export type TurnDirection = 'clockwise' | 'counterclockwise';

const orientations: readonly Orientation[] = [0, 90, 180, 270];

/** Orientation après un quart de tour ; quatre quarts de tour ramènent à l'origine. */
export function turn(orientation: Orientation, direction: TurnDirection): Orientation {
  const delta = direction === 'clockwise' ? 90 : 270;
  return ((orientation + delta) % 360) as Orientation;
}

/**
 * Orientation retenue d'une page : une page absente, un document sans orientations ou une
 * valeur qui n'est pas un quart de tour comptent pour droits.
 */
export function orientationOfPage(
  pageOrientations: PageOrientations | null | undefined,
  page: number,
): Orientation {
  const value = pageOrientations?.[String(page)];
  return orientations.includes(value as Orientation) ? (value as Orientation) : 0;
}
